import "./userIsTabbing";
import './fixHashLinks';

import "../../views/components/index";
import "../../views/blocks/index";
import "../../views/macros/index";

import "../styles/main.scss";

import { gsap } from 'gsap';
import ScrollTrigger from "gsap/ScrollTrigger";
import { barbaInit } from "./barbaInit";

import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import collapse from '@alpinejs/collapse';

(window as any).Alpine = Alpine;

gsap.registerPlugin(ScrollTrigger);

/* put everything you need for initialisation in this init function... */
function init() {
  Alpine.plugin(focus);
  Alpine.plugin(collapse);
  Alpine.start();

  if (!document.querySelector('.admin-bar')) {
    barbaInit();
  }
}

document.addEventListener("DOMContentLoaded", init);
